.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .emptyViewTitle {
    margin-bottom: var(--spacer);
  }

  .emptyViewText {
    line-height: 19px;
    .emptyViewLink {
      margin-left: var(--spacer);
    }
  }

  #section-description {
    max-width: 600px;
    display: inline-block;
    padding-top: calc(var(--spacer) * 4);

    gz-info-box::part(container) {
      margin: 0 0 calc(var(--spacer) * 4) 0;
    }
  }

  .beta-programs-section {
    max-width: 600px;
    margin-bottom: 32px;

    #beta-programs-title {
      width: 100%;
      display: flex;
      margin-top: calc(var(--spacer) * 4);
      border-bottom: 1px solid var(--chart-101-pressed-dividers);

      .beta-title-element {
        width: 50%;
        color: var(--chart-302-icon-buttons-titles);
        min-height: 32px;
        display: flex;
        align-items: center;
        &:first-child {
          min-width: 314px;
          margin-right: calc(var(--spacer) * 2);
        }
      }

      #status-title {
        margin-right: calc(var(--spacer) * 2);
        max-width: 116px;
        padding-left: calc(var(--spacer) / 2);
      }
    }
  }

  .beta-programs-buttons {
    margin-right: 20px;
  }
}
